import React, { Component } from 'react';
import HeaderTwo from '../../components/mondiya/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/mondiya/Breadcrumb';
import AboutUs from '../../components/mondiya/AboutUs';
import FooterTwo from '../../components/mondiya/FooterTwo';
import { Styles } from "./styles/about.js";
import {withTranslation} from "react-i18next";

class About extends Component {

    render() {
        const { t } = this.props;
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper about-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title={t('aboutUsPage.breadcrumbs')} />

                    {/* About Area */}
                    <AboutUs />

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
    }
}

export default withTranslation()(About);